import PropTypes from 'prop-types';
import React from 'react';

const CustomTemplate = ({ ElementType, template, context }) => (
  <ElementType
    dangerouslySetInnerHTML={
      {
        __html: template(context),
      }
    }>
  </ElementType>
);

CustomTemplate.propTypes = {
  context: PropTypes.object.isRequired,
  ElementType: PropTypes.string.isRequired,
  template: PropTypes.func.isRequired,
};

CustomTemplate.defaultProps = {
  context: {},
  ElementType: 'div',
};

export default CustomTemplate;
